import { getData } from '../../axiosServices'

export const getTimeSlotsByLab = (labID) => {
    const url = `labDailyAttendance/timeSlots/${labID}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const getAttendanceByLab = (labID) => {
    const url = `labDailyAttendance/attendanceName/${labID}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const getReportForMentorMobile = ( labID) => {
    const url = `labDailyAttendance/lab/${labID}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return getData(url, { headers });
};
export const getReportForMentor = (coeId, labID, timeSlot,AttendanceId) => {
    const url = `reports/attendance_report?dailyAttendanceId=${AttendanceId}&timeSlot=${timeSlot}&lab_id=${labID}&coe_id=${coeId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    return getData(url, { headers });
};
export const getPresentAbsent = (coeId, labID, date,dailyAttendanceId) => {
    const url = `reports/present_absent_engineers?attendanceDate=${date}&coe_id=${coeId}&lab_id=${labID}&dailyAttendanceId=${dailyAttendanceId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    return getData(url, { headers });
};

export const refreshAttendanceReport = async (labID,coeId, date) => {
    const url = `reports/attendance_report?attendanceDate=${date}&coe_id=${coeId}&lab_id=${labID}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url,  { headers })
};

